import { useState } from "react";

export const SummaryOverviewItem = (props) => {
  const [quantity, setQuantity] = useState(
    props.completedSet ? props.quantity : props.item.quantity
  );

  let tdStyle = { textAlign: "right" };

  if (props.completedSet) {
    tdStyle["padding"] = "10px 17px";
  } else {
    tdStyle["paddingRight"] = 17;
  }

  if (props.item.price > 0) {
    const numberOfPieces = props.completedSet ? (
      <td>{props.quantity} ks</td>
    ) : (
      <td>
        <div style={{ paddingLeft: 77 }}>
          <select
            className="form-control"
            id={props.type}
            onChange={changeQuantity}
          >
            <option value="1">1 ks</option>
            <option value="2">2 ks</option>
            <option value="3">3 ks</option>
            <option value="4">4 ks</option>
            <option value="5">5 ks</option>
            <option value="6">6 ks</option>
            <option value="7">7 ks</option>
            <option value="8">8 ks</option>
            <option value="9">9 ks</option>
            <option value="10">10 ks</option>
          </select>
        </div>
      </td>
    );

    function removeButton() {
      if (props.completedSet) {
        return null;
      } else {
        return (
          <td>
            <div style={{ cursor: "pointer" }}>
              <img
                src={props.removeImageUrl}
                onClick={() =>
                  this.props.removeFromCategorySelection(
                    this.props.item,
                    this.props.type
                  )
                }
                title="Odebrat z výběru"
              />
            </div>
          </td>
        );
      }
    }

    function changeQuantity(e) {
      let new_quantity = e.target.value;
      props.handleQuantityChange(props.type, quantity);

      $.post(
        "/tvorba-setu/change_quantity",
        { category: props.type, quantity: new_quantity },
        function (data) {
          setQuantity(new_quantity);
        }.bind(this)
      );
    }
    function checkAvailibilityAndDeliveryDate() {
      if (props.item.quantity_in_stock_label === "vyprodáno") {
        return (
          <div className="availability" style={{ paddingTop: 0 }}>
            <strong
              className="availability-state supplier-in-stock warning"
              style={{ marginRight: 0, color: "#C30000" }}
            >
              vyprodáno
            </strong>
          </div>
        );
      } else {
        return (
          <div
            className="availability"
            style={{ paddingTop: 0, color: "rgb(45, 165, 20)" }}
          >
            <strong className="available-quantity" style={{ marginRight: 0 }}>
              {props.item.quantity_in_stock_label}
            </strong>

            <div
              className="availability-state.in-stock"
              style={{ paddingTop: 0 }}
            >
              u vás doma {props.item.delivery_date}
            </div>
          </div>
        );
      }
    }

    return (
      <tr className="product-set-item" key={props.item.pr_id}>
        <td style={{ padding: "10px 25px" }}>
          <a href={props.item.link}>
            <img
              style={
                props.item.quantity_in_stock_label === "vyprodáno"
                  ? { filter: "grayscale(100%)", opacity: "0.3" }
                  : {}
              }
              src={props.item.thumb_image_url}
            />
          </a>
        </td>

        <td
          className="item-name"
          style={{ padding: "10px 60px", maxWidth: 250 }}
        >
          <a
            onClick={() => {
              openModalProductDetail(props.item.link);
            }}
            style={{ fontSize: 17 }}
          >
            {props.item.name}
          </a>
          <br />
          {props.item.category_name_singular}
          <div
            className="delivery-info-responsive"
            style={{ display: "none", paddingTop: 5 }}
          >
            {checkAvailibilityAndDeliveryDate()}
          </div>
        </td>
        <td>{checkAvailibilityAndDeliveryDate()}</td>

        {numberOfPieces}

        <td className="item-price" style={tdStyle}>
          <div style={{ fontSize: 17, marginTop: 0, fontWeight: "bold" }}>
            běžná cena {formatMoney(props.item.price * quantity)}
          </div>

          <div style={{ color: "gray" }}>
            bez DPH 
            {formatMoney(props.item.price_without_vat * quantity)}
          </div>
        </td>

        {removeButton()}
      </tr>
    );
  } else {
    return <tr />;
  }
};
